import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createFaqRequest,
  getFaqs,
  removeFaq,
  updateFaqRequest,
} from "../../../../services/api/landing/faqs/faqsApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: {
    en: "FAQ created successfully!",
    ar: "تم إنشاء سؤال شائع بنجاح!",
  },
  addError: {
    en: "Failed to create FAQ.",
    ar: "فشل في إنشاء سؤال شائع.",
  },
  update: {
    en: "FAQ updated successfully!",
    ar: "تم تحديث سؤال شائع بنجاح!",
  },
  updateError: {
    en: "Failed to update FAQ.",
    ar: "فشل في تحديث سؤال شائع.",
  },
  delete: {
    en: "FAQ deleted successfully!",
    ar: "تم حذف سؤال شائع بنجاح!",
  },
  deleteError: {
    en: "Failed to delete FAQ.",
    ar: "فشل في حذف سؤال شائع.",
  },
};

export const fetchFaqs = createAsyncThunk(
  "faqs/fetchFaqs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getFaqs();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch FAQs");
    }
  },
);

export const createFaq = createAsyncThunk(
  "faqs/createFaq",
  async (faqData, { rejectWithValue }) => {
    try {
      const response = await createFaqRequest(faqData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create FAQ");
    }
  },
);

export const updateFaq = createAsyncThunk(
  "faqs/updateFaq",
  async ({ id, faqData }, { rejectWithValue }) => {
    try {
      const response = await updateFaqRequest(id, faqData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update FAQ");
    }
  },
);

export const deleteFaq = createAsyncThunk(
  "faqs/deleteFaq",
  async (faqId, { rejectWithValue }) => {
    try {
      await removeFaq(faqId);
      return faqId;
    } catch (error) {
      return rejectWithValue("Failed to delete FAQ");
    }
  },
);

const faqsSlice = createSlice({
  name: "faqs",
  initialState: {
    faqData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.loading = false;
        state.faqData = action.payload;
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createFaq.fulfilled, (state, action) => {
        state.faqData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createFaq.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updateFaq.fulfilled, (state, action) => {
        const index = state.faqData.findIndex(
          (faq) => faq.id === action.payload.id,
        );
        if (index !== -1) {
          state.faqData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateFaq.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deleteFaq.fulfilled, (state, action) => {
        state.faqData = state.faqData.filter(
          (faq) => faq.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deleteFaq.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default faqsSlice.reducer;
